/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const HeroiconsSolidBars4 = ({ className }) => {
  return (
    <svg
      className={`heroicons-solid-bars-4 ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        clipRule="evenodd"
        d="M2 3.75C2 3.33579 2.33579 3 2.75 3H17.25C17.6642 3 18 3.33579 18 3.75C18 4.16421 17.6642 4.5 17.25 4.5H2.75C2.33579 4.5 2 4.16421 2 3.75ZM2 7.91667C2 7.50245 2.33579 7.16667 2.75 7.16667H17.25C17.6642 7.16667 18 7.50245 18 7.91667C18 8.33088 17.6642 8.66667 17.25 8.66667H2.75C2.33579 8.66667 2 8.33088 2 7.91667ZM2 12.0833C2 11.6691 2.33579 11.3333 2.75 11.3333H17.25C17.6642 11.3333 18 11.6691 18 12.0833C18 12.4975 17.6642 12.8333 17.25 12.8333H2.75C2.33579 12.8333 2 12.4975 2 12.0833ZM2 16.25C2 15.8358 2.33579 15.5 2.75 15.5H17.25C17.6642 15.5 18 15.8358 18 16.25C18 16.6642 17.6642 17 17.25 17H2.75C2.33579 17 2 16.6642 2 16.25Z"
        fill="#7041F1"
        fillRule="evenodd"
      />
    </svg>
  );
};
